export let dev = ""; // ローカル開発の場合は""を"http://localhost:8080"に修正